import { getError } from "@/utils/get-error";
import { axiosInstance } from "@dexteel/mesf-core";
import { Axios } from "axios";

export class PartStateRepository {
	private axios: Axios;

	constructor() {
		this.axios = axiosInstance;

		this.getPartState = this.getPartState.bind(this);
		this.getPartStateById = this.getPartStateById.bind(this);
	}

	async getPartState() {
		try {
			const resp = await this.axios.get("/PartState/");

			return {
				ok: true,
				data: resp,
			};
		} catch (error: any) {
			const message = getError(error);
			return Promise.reject(message);
		}
	}

	async getPartStateById(partStateId: number | null) {
		try {
			const resp = await this.axios.get(`/PartState/${partStateId}`);

			return {
				ok: true,
				data: resp,
			};
		} catch (e: any) {
			return { ok: false, message: e.toString() };
		}
	}
}

export const { getPartState, getPartStateById } = new PartStateRepository();
